export const all = state => state.news.all;
export const allApi = state => state.news.allApi;
export const updatedAt = state => state.news.updatedAt;
